import { Component, OnInit, Inject } from '@angular/core';
import { Globals } from '../../../../globals'
import { FormGoalsAndBenchmarksService } from "../../../../Services/FormGoalsAndBenchmarksService";
import { ISpedStudentDemographics } from '../../../../Models/ISpedStudentDemographics'
import { IIepInstance } from '../../../../Models/IIepInstance'
import { IFormGoalsAndBenchmarks } from "../../../../Models/Forms/IFormGoalsAndBenchmarks";
import { IepService } from "../../../../Services/IepService";
import { ILockStatus } from '../../../../Models/ILockStatus';
import { Message } from 'primeng/primeng';
import { Router } from "@angular/router";
import { ILookupBase } from '../../../../Models/ILookupBase';
import { ILookupGoal } from '../../../../Models/ILookupGoal';
import { LookupService } from 'src/app/Services/LookupService';
import { LookupTypeEnum } from 'src/app/Models/Enums/LookupTypeEnum';
import { IReportParameter } from 'src/app/Models/IReportParameter';
import { SpinnerBase } from '../../../Base/SpinnerBase';
import { ReportService } from 'src/app/Services/ReportService';
import { ConfirmationService } from 'primeng/api';

@Component({
  selector: 'GoalsAndBenchmarks',
  templateUrl: './GoalsAndBenchmarks.component.html',
  styleUrls: ['./GoalsAndBenchmarks.component.css'],
  providers: [ConfirmationService]
})

export class FormGoalsAndBenchmarksComponent extends SpinnerBase implements OnInit {
  _myGlobals: Globals;
  _baseUrl: string;
  _iepService: IepService;
  successMessages: Message[];
  errorMessages: Message[];
  studentInfo: ISpedStudentDemographics;
  selectedIepInstance: IIepInstance;
  confirmDialogVisible = false;
  isLocked: boolean;
  lockStatus: string;
  canEditIep: boolean;
  performanceAreaDisabled: boolean;
  sped4DeployDate: Date;
  saveClicked: boolean;
  isGoalBankExpand: boolean = false;
  goalsAndBenchmarksDB: any = [];
  lookupPerformanceArea: ILookupBase[];
  lookupServiceProvider: ILookupBase[];
  lookupGoalBank: ILookupGoal[];
  GoalBankSelected: ILookupGoal;
  isGoalBankselected: boolean = false;
  _lookupService: LookupService;
  _lookupTypeEnum: LookupTypeEnum;
  reportParamArray: IReportParameter[];
  meetingDate: Date;
  yearMinusOneDay: Date;
  temporaryMaxDate: Date;
  threeYearsBack: Date;
  //public showSpinner: boolean = false;

  constructor(
    private globals: Globals, reportService: ReportService,
    private _formGoalsAndBenchmarksService: FormGoalsAndBenchmarksService,
    iepService: IepService,
    private confirmation: ConfirmationService,
    @Inject('BASE_URL') baseUrl: string,
    public router: Router,
    lookupService: LookupService) {
    super(reportService);
    this._iepService = iepService;
    this._myGlobals = globals;
    this._baseUrl = baseUrl;
    this.studentInfo = this._myGlobals.spedStudentDemographics;
    this.selectedIepInstance = this._myGlobals.selectedIepInstance;
    this._lookupService = lookupService;
  }

  ngOnInit(): void {
    this.LoadFormGoalsAndBenchmarksDetails();
    this.LoadLookupValues();
    this.isLocked = false;
    this.canEditIep = this._myGlobals.canEdit();
    this.sped4DeployDate = this._myGlobals.deployDate;
    this.scrollToTop();
    this.successMessages = [];
    this.errorMessages = [];
    this.meetingDate = this._myGlobals.selectedIepInstance.meetingDate;
    this.yearMinusOneDay = new Date(this.meetingDate.getFullYear() + 1, this.meetingDate.getMonth(), this.meetingDate.getDate() > 1 ? this.meetingDate.getDate() - 1 : this.meetingDate.getDate());
    this.temporaryMaxDate = new Date(this.meetingDate.getFullYear() + 2, this.meetingDate.getMonth(), this.meetingDate.getDate() > 1 ? this.meetingDate.getDate() - 1 : this.meetingDate.getDate());
    this.threeYearsBack = new Date(this.meetingDate.getFullYear() - 3, this.meetingDate.getMonth(), this.meetingDate.getDate());
  }

  LoadFormGoalsAndBenchmarksDetails(): void {
    this._formGoalsAndBenchmarksService.getFormGoalsAndBenchmarks(this._myGlobals.selectedFormDetails.formId)
      .subscribe((res: IFormGoalsAndBenchmarks) => {
        this.goalsAndBenchmarksDB = res;
        this.goalsAndBenchmarksDB.dateOfForm = this.goalsAndBenchmarksDB.dateOfForm == null ? new Date(this.meetingDate) : new Date(this.goalsAndBenchmarksDB.dateOfForm);
        this.goalsAndBenchmarksDB.dateMet = this.goalsAndBenchmarksDB.dateMet == null ? null : new Date(this.goalsAndBenchmarksDB.dateMet);
        this.goalsAndBenchmarksDB.annualGoalByFirst = this.goalsAndBenchmarksDB.annualGoalByFirst == null ? null : new Date(this.goalsAndBenchmarksDB.annualGoalByFirst);
        this.goalsAndBenchmarksDB.firstBenchmarkObjectiveByFirst = this.goalsAndBenchmarksDB.firstBenchmarkObjectiveByFirst == null ? null : new Date(this.goalsAndBenchmarksDB.firstBenchmarkObjectiveByFirst);
        this.goalsAndBenchmarksDB.secondBenchmarkObjectiveByFirst = this.goalsAndBenchmarksDB.secondBenchmarkObjectiveByFirst == null ? null : new Date(this.goalsAndBenchmarksDB.secondBenchmarkObjectiveByFirst);
        if (this.goalsAndBenchmarksDB.metUnmet == '-') {
          this.goalsAndBenchmarksDB.metUnmet = 'U';
        }
        if (this.goalsAndBenchmarksDB.areaAddressed != null && this.goalsAndBenchmarksDB.areaAddressed != '23') {
          this.performanceAreaDisabled = false
        }
        this.LoadGoalBankList();
      },
        err => console.error(err)
      );
  }

  LoadLookupValues() {
    this._lookupService.getLookupArray(this._baseUrl + 'api/Lookup/GetLookupList?lookupTableName=' + LookupTypeEnum[LookupTypeEnum.AddressedArea])
      .subscribe((res: ILookupBase[]) => {
        this.lookupPerformanceArea = res
      },
        err => console.error(err)
      );

    this._lookupService.getLookupArray(this._baseUrl + 'api/Lookup/GetLookupList?lookupTableName=' + LookupTypeEnum[LookupTypeEnum.ServiceProviderCategory])
      .subscribe((res: ILookupBase[]) => {
        this.lookupServiceProvider = [{ value: null, label: "-- Select One --", shortText: null, updatedOn: null }].concat(res)
      },
        err => console.error(err)
      );
  }

  LoadGoalBankList() {
    this._lookupService.getLookupGoalList(parseInt(this.goalsAndBenchmarksDB.areaAddressed))
      .subscribe((res: ILookupGoal[]) => {
        this.lookupGoalBank = res
      },
        err => console.error(err)
      );
  }

  clearMessages() {
    this.successMessages = [];
    this.errorMessages = [];
  }

  addMessage(msg: Message) {
    if (msg.severity == 'error') {
      this.errorMessages = [...this.errorMessages, msg];
    }
    else {
      this.successMessages = [...this.successMessages, msg];
    }
  }

  //Save the Goals And Benchmarks
  save(action) {
    this.scrollToTop();
    this.clearMessages();
    this.saveClicked = true;
    if (this.goalsAndBenchmarksDB.metUnmet == 'U') {
      this.goalsAndBenchmarksDB.metUnmet = '-';
    }
    //update values
    this._formGoalsAndBenchmarksService.insertUpdateFormGoalsAndBenchmarks(this.goalsAndBenchmarksDB)
      .subscribe((res: IFormGoalsAndBenchmarks) => {
        let successMessage: Message = { severity: 'success', summary: 'Record Saved Successfully', detail: res.id.toString() }
        this.addMessage(successMessage);
        if (action == 'Close') {
          this.globals.editMode = false;
          this.loadUnLock("UnLock");
        }
        this.saveClicked = false
        this.validateForm();
        this.LoadFormGoalsAndBenchmarksDetails();
      },
        (error) => {
          let errorMessage: Message = { severity: 'error', summary: 'Save Failed', detail: error };
          this.addMessage(errorMessage);
          this.saveClicked = false;
        }
      )
  }

  validateForm() {
    this._formGoalsAndBenchmarksService.validateForm(this._myGlobals.selectedFormDetails.formId).subscribe((res: string[]) => {
      for (var item of res) {
        let errorMessage: Message = { severity: 'error', summary: 'Validation Error', detail: item };
        this.addMessage(errorMessage);
      }
    },
      err => console.error(err)
    );
  }

  loadUnLock(action) {
    this._iepService.lockUnlockForm(this._baseUrl + 'api/Iep/LockUnlockForm?formInstanceId='
      + this._myGlobals.selectedFormDetails.formInstanceId + '&action=' + action)
      .subscribe((res: ILockStatus) => {
        this.isLocked = res.success
        this.lockStatus = res.status
      },
        err => console.error(err)
      );
  }

  edit() {
    this.clearMessages();
    this.saveClicked = false;
    this._iepService.lockUnlockForm(this._baseUrl + 'api/Iep/LockUnlockForm?formInstanceId='
      + this._myGlobals.selectedFormDetails.formInstanceId + '&action=Lock')
      .subscribe((res: ILockStatus) => {
        this.isLocked = res.success
        this.lockStatus = res.status
        if (this.isLocked == true) {
          this.globals.editMode = true;
        }
        else {
          let failedMessage: Message = { severity: 'warn', summary: this.lockStatus }
          this.addMessage(failedMessage);
          this.saveClicked = false;
        }
      });
  }

  showGoalBank() {
    this.isGoalBankExpand = true;
  }

  hideGoalBank() {
    this.isGoalBankExpand = false;
  }

  confirmApplyGoal(goalType: string) {
    this.confirmation.confirm({
      key: 'confirm-complete-casefile',
      message: 'The selected goal will be published in the selected area.\r\nAny existing goal will be erased. \r\nPress Yes to proceed.',
      accept: () => { this.applySelectedGoal(goalType); },
    });
  }

  selectedGoalBank(Id: number) {
    this.isGoalBankselected = true;
    this.GoalBankSelected = this.lookupGoalBank.find(x => x.id === Id);
  }

  applySelectedGoal(goalType: string) {
    if (goalType == "Goal1") {
      this.goalsAndBenchmarksDB.annualGoalBySecond = this.GoalBankSelected.commonCoreNumber;
      this.goalsAndBenchmarksDB.annualGoalComments = this.GoalBankSelected.goal;
    }
    else if (goalType == "Goal2") {
      this.goalsAndBenchmarksDB.firstBenchmarkObjectiveBySecond = this.GoalBankSelected.commonCoreNumber;
      this.goalsAndBenchmarksDB.firstBenchmarkObjectiveComments = this.GoalBankSelected.goal;
    }
    else if (goalType == "Goal3") {
      this.goalsAndBenchmarksDB.secondBenchmarkObjectiveBySecond = this.GoalBankSelected.commonCoreNumber;
      this.goalsAndBenchmarksDB.secondBenchmarkObjectiveComments = this.GoalBankSelected.goal;
    }
  }

  cancel() {
    this.clearMessages();
    this.globals.editMode = false;
    this.loadUnLock("UnLock");
    this.LoadFormGoalsAndBenchmarksDetails();
  }

  populateReportParameters() {
    this.reportParamArray = [];
    this.reportParamArray.push(
      { parameterName: 'dtFrmEdited', parameterValue: this.goalsAndBenchmarksDB.updatedOn.toString() },
      { parameterName: 'RequestID', parameterValue: '0' },
      { parameterName: 'isDraft', parameterValue: this._myGlobals.selectedDashboardDocument.status == 'Draft' ? 'True' : 'False' },
      { parameterName: 'FormInstanceID', parameterValue: this.goalsAndBenchmarksDB.iepFormInstanceId.toString() },
      { parameterName: 'ShowCustomWaterMark', parameterValue: this._myGlobals.selectedDashboardDocument.status == 'Draft' ? 'true' : 'false' },
      { parameterName: 'CustomWatermarkText', parameterValue: 'DRAFT DRAFT DRAFT' },
      { parameterName: 'FormVersionID', parameterValue: '' },
      { parameterName: 'StudentID', parameterValue: this.goalsAndBenchmarksDB.localStudentId.toString() },
      { parameterName: 'IEPID', parameterValue: this.goalsAndBenchmarksDB.iepId.toString() },
      { parameterName: 'BlankForm', parameterValue: 'false' },
      //{ parameterName: 'ReportPath', parameterValue: '' }
    );
  }

  printEnglish() {
    this.populateReportParameters();
    this.printFormCommon(this.goalsAndBenchmarksDB.rdlFileNameEnglish, this.reportParamArray);
  }

  printSpanish() {
    this.populateReportParameters();
    this.printFormCommon(this.goalsAndBenchmarksDB.rdlFileNameSpanish, this.reportParamArray);
  }


  onMetUnmetChange() {
    if (this.goalsAndBenchmarksDB.metUnmet === 'Y') {
      this.goalsAndBenchmarksDB.unMetComments = null;
    }
    else if (this.goalsAndBenchmarksDB.metUnmet === 'N') {
      this.goalsAndBenchmarksDB.dateMet = null;
    }
    else if (this.goalsAndBenchmarksDB.metUnmet === 'U') {
      this.goalsAndBenchmarksDB.dateMet = null;
      this.goalsAndBenchmarksDB.unMetComments = null;
    }
  }
}
